// extracted by mini-css-extract-plugin
export default {"labelRow":"labelRow---U1N2I","label":"label---RT8gT"};